import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";
/* Types & Action Creators */

const { Types, Creators } = createActions({
  signInRequest: ["email", "password"],
  signInSuccess: ["userActive"],
  signInFailure: ["error"],
});

export const AuthTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  authChecked: false,
  signedIn: false,
  isLoading: false,
  error: null,
  userActive: null,
});

/* Reducers */

export const signInReq = (state) => state.merge({ isLoading: true });
export const signInSuc = (state, { userActive }) =>
  state.merge({ signedIn: true, isLoading: false, userActive });
export const signInFail = (state, { error }) =>
  state.merge({
    isLoading: false,
    error: !!error,
    signedIn: false,
    userActive: null,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SIGN_IN_REQUEST]: signInReq,
  [Types.SIGN_IN_SUCCESS]: signInSuc,
  [Types.SIGN_IN_FAILURE]: signInFail,
});
